import { render, staticRenderFns } from "./BookingNew.vue?vue&type=template&id=8f5f5c1c&scoped=true"
import script from "./BookingNew.vue?vue&type=script&lang=js"
export * from "./BookingNew.vue?vue&type=script&lang=js"
import style0 from "./BookingNew.vue?vue&type=style&index=0&id=8f5f5c1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5f5c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f5f5c1c')) {
      api.createRecord('8f5f5c1c', component.options)
    } else {
      api.reload('8f5f5c1c', component.options)
    }
    module.hot.accept("./BookingNew.vue?vue&type=template&id=8f5f5c1c&scoped=true", function () {
      api.rerender('8f5f5c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/BookingNew.vue"
export default component.exports